'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isAsaCompliant = function isAsaCompliant(text) {
  var asaTags = ['#ad\b', '#spon', '#partner'];
  var asaRegex = new RegExp(_lodash2.default.join(asaTags, '|'), 'ig');
  var isCompliant = asaRegex.test(text);
  return isCompliant;
};

exports.default = isAsaCompliant;


/*****************
 ** WEBPACK FOOTER
 ** ./~/dyzio-shared-components/lib/utils/asa-compliance.js
 ** module id = 969
 ** module chunks = 0
 **/